// Fuente canónica de la versión de la plataforma (policies/versioning.md). La UI la muestra en el
// shell: cuando alguien reporta «esto no me anda», lo primero que hace falta saber es contra qué
// versión está mirando. Un número que vive en dos lugares es un número que ya está desincronizado.
export const APP_VERSION = 'v0.7.3';
